// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_Q2I","cls2":"SimplePaperPodcast-cls2_VSw SimplePaperPodcast-cls1_Q2I"};